export const STORAGE_PATH = '/uslugi/proektirovanie-i-dizayn/proektirovanie-sistem-hraneniya/';

export const STORAGE_CDN_NAME = 'storage-mf';

export const STORAGE_LANDING_NAME = 'storage';

export const STORAGE_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/storage-mf';

export const STORAGE_DESIGN_SIGN_UP_HREF = '/zapis-onlayn/?department_no=14&region_id=';

export const STORAGE_DESIGN_PROJECT_HREF = '/3d-planirovshchiki/hranenie/';

export const STORAGE_ELEMENT_BLOCK = 'landingStorageSystems';
